import { render, staticRenderFns } from "./SO.vue?vue&type=template&id=d7960b5a"
import script from "./SO.vue?vue&type=script&lang=js"
export * from "./SO.vue?vue&type=script&lang=js"
import style0 from "./SO.vue?vue&type=style&index=0&id=d7960b5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports